// extracted by mini-css-extract-plugin
module.exports = {"root":"SingleImg_root__gDWBd","singleImg":"SingleImg_singleImg__gLznH","caption":"SingleImg_caption__Pl9GU"};